module.exports = require("./jv.d.ts");